import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import {
  PublicClientApplication,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';

const useRegRedirectionAuthTokenEU = () => {
  const { accounts, inProgress } = useMsal();
  const [accessToken, setAccessToken] = useState('');

  useEffect(() => {
    const initializeMsal = async () => {
      if (process.env.REACT_APP_MULTI_REGION_ALLOW === `true`) {
        const authConfig = {
          clientId: process.env.REACT_APP_AZURE_CLIENT_ID_EU,
          authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_APPLICATION_ID}`,
          redirectUri: `${process.env.REACT_APP_URL_BASE}home`,
          navigateToLoginRequestUrl: true,
          applicationId: process.env.REACT_APP_AZURE_APPLICATION_ID,
        };

        const cache = {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false,
        };
        const msalConfig = {
          auth: authConfig,
          cache: cache,
        };

        const msalInstance = new PublicClientApplication(msalConfig);

        const request = {
          scopes: [process.env.REACT_APP_EU_TOKEN_SCOPE],
          account: accounts[0],
        };
        try {
          // Ensure MSAL instance is initialized
          await msalInstance.initialize();

          if (inProgress === 'none' && accounts.length > 0) {
            const response = await msalInstance.acquireTokenSilent(request);
            setAccessToken(response.accessToken);
          }
        } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            await msalInstance.acquireTokenRedirect(request);
          }
          console.error('Token acquisition failed:', error);
        }
      }
    };

    initializeMsal();
  }, [inProgress, accounts]);

  return accessToken;
};

export { useRegRedirectionAuthTokenEU };
